import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function customers() {
    return {
        index,
        get,
        searchAddress,
        create,
        remove,
        createAddress,
        update,
        importCustomer,
        updateAddress,
        getAddress,
        removeAddress
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            hasPobox: true,
            sort: 'creationDate:desc' // TODO: The endpoint return error 500 if this field is null. Remover after endpoint fixed.
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`customer/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`customer/get?id=${id}`);
    }

    function create(payload) {
        return axiosInstance.post('customer/create', payload);
    }

    function update(payload) {
        return axiosInstance.patch('customer/update', payload);
    }

    function importCustomer(payload) {
        const formData = new FormData();

        formData.append('agency', payload.agency);
        formData.append('location', payload.location);
        if (payload.ImportCustomers) {
            formData.append('ImportCustomers', payload.ImportCustomers);
        }

        return axiosInstance.post('customer/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function remove(id) {
        return axiosInstance.delete('customer/delete', {
            data: {
                id: id
            }
        });
    }

    function getAddress(addressId) {
        return axiosInstance.get(`baddr/get?id=${addressId}`);
    }

    function searchAddress(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`baddr/search${params}`);
    }

    function createAddress(payload) {
        return axiosInstance.post('baddr/create', payload);
    }

    function updateAddress(payload) {
        return axiosInstance.patch('baddr/update', payload);
    }

    function removeAddress(id) {
        return axiosInstance.delete('baddr/delete', {
            data: {
                id: id
            }
        });
    }
}
